import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';

@Component({
	selector: 'app-assesment-success-dialog-box',
	standalone: true,
	imports: [RouterModule, CommonModule, MatDialogModule],
	templateUrl: './assesment-success-dialog-box.component.html',
	styleUrl: './assesment-success-dialog-box.component.scss'
})
export class AssesmentSuccessDialogBoxComponent {

	assessmentTitle: string = '';

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<AssesmentSuccessDialogBoxComponent>,
		private router: Router
	) {
		if (data?.title) {
			this.assessmentTitle = data.title;
		}
	}


	goToHome() {
		if (this.data?.isFromMockTest) {
			this.dialogRef.close();
			this.router.navigate(['/student-dashboard/placement-prep'], { queryParams: { tab: 'history' } });
			return;
		}
		if (this.data?.isFromStudentDashboard) {
			this.dialogRef.close();
			this.router.navigate(['student-dashboard/jobs/my-applications']);
			return;
		}
		this.dialogRef.close();
		this.router.navigate(['/']);
	}


}
